import clsx from 'clsx'
import { ReactNode } from 'react'

import { Flex } from 'components/common/flex/Flex'

import styles from './Button.module.scss'

interface Props {
  text: string
  iconLeft?: ReactNode
  iconRight?: ReactNode
  variant?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'black'
    | 'white'
    | 'textWhite'
    | 'transparentWhite'
    | 'transparentBlack'
    | 'smallGrayTertiary'
    | 'textBlack'
  small?: boolean
  onClick?: () => void
  onClickDisabled?: () => void
  className?: string
  disabled?: boolean
}
export const Button = ({
  className,
  text,
  iconLeft,
  iconRight,
  variant = 'primary',
  small = false,
  onClick = () => {},
  onClickDisabled,
  disabled = false,
}: Props) => {
  return (
    <Flex
      className={clsx(
        styles.flexBaseWidth,
        variant === 'smallGrayTertiary' && disabled && 'text-[#8B8B8B] border-[#8B8B8B] hover:cursor-not-allowed',
        variant === 'smallGrayTertiary' && !disabled && 'hover:cursor-pointer',
        variant === 'primary' && disabled && 'hover:cursor-not-allowed bg-[#B6B6B6]',
        variant === 'transparentWhite' && disabled && 'hover:cursor-not-allowed border-[#B6B6B6] text-[#B6B6B6]',
        styles[variant],
        small && styles.small,
        className,
      )}
      inline
      align="center"
      justify="center"
      gap={8}
      onClick={() => {
        if (disabled) {
          onClickDisabled && onClickDisabled()
          return
        }
        onClick()
      }}
    >
      {iconLeft}
      <div>{text}</div>
      {iconRight}
    </Flex>
  )
}
